import { getField } from 'vuex-map-fields';
import Vue from 'vue';

// TYPES
export const SET_FILTER_MES_DESDE = 'SET_FILTER_MES_DESDE';
export const SET_FILTER_MES_HASTA = 'SET_FILTER_MES_HASTA';
export const SET_FILTER_EJERCICIO = 'SET_FILTER_EJERCICIO';
export const SET_EJERCICIO_USER_VALUES = 'SET_EJERCICIO_USER_VALUES';
export const RESET_FILTERS = 'RESET_FILTERS';

// STATE
const state = () => ({
    dashboardFilters: {
        mes_desde: {
            'name': 'mes_desde',
            'label': 'Mes desde',
            'values': [],
            'user_values': [
                { value: '', text: 'Todos' },
                { value: '1', text: 'Enero' },
                { value: '2', text: 'Febrero' },
                { value: '3', text: 'Marzo' },
                { value: '4', text: 'Abril' },
                { value: '5', text: 'Mayo' },
                { value: '6', text: 'Junio' },
                { value: '7', text: 'Julio' },
                { value: '8', text: 'Agosto' },
                { value: '9', text: 'Septiembre' },
                { value: '10', text: 'Octubre' },
                { value: '11', text: 'Noviembre' },
                { value: '12', text: 'Diciembre' }
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-calendar-month',
            'text': ''
        },
        mes_hasta: {
            'name': 'mes_hasta',
            'label': 'Mes hasta',
            'values': [],
            'user_values': [
                { value: '', text: 'Todos' },
                { value: '1', text: 'Enero' },
                { value: '2', text: 'Febrero' },
                { value: '3', text: 'Marzo' },
                { value: '4', text: 'Abril' },
                { value: '5', text: 'Mayo' },
                { value: '6', text: 'Junio' },
                { value: '7', text: 'Julio' },
                { value: '8', text: 'Agosto' },
                { value: '9', text: 'Septiembre' },
                { value: '10', text: 'Octubre' },
                { value: '11', text: 'Noviembre' },
                { value: '12', text: 'Diciembre' }
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-calendar-month',
            'text': ''
        },
        ejercicio: {
            'name': 'ejercicio',
            'label': 'Ejercicio',
            'values': [],
            'user_values': [
                { value: '2023', text: '2023' },
                { value: '2024', text: '2024' },
                { value: '2025', text: '2025' }
            ],
            'multiple': true,
            'value': '',
            'type': 'select',
            'icon': 'mdi-calendar-range',
            'text': ''
        }
    }
});

// GETTERS
const getters = {
    dashboardFilters: state => state.dashboardFilters,
    getField
}

// ACTIONS
const removeAllFilters = ({ commit }) => {
    let text = ''
    let value = ''
    commit(SET_FILTER_MES_DESDE, { value, text });
    commit(SET_FILTER_MES_HASTA, { value, text });
    commit(SET_FILTER_EJERCICIO, { value, text });
}

const updateObject = ({ commit }, { key, value, text }) => {
    if (key == 'mes_desde')
        commit(SET_FILTER_MES_DESDE, { value, text });
    if (key == 'mes_hasta')
        commit(SET_FILTER_MES_HASTA, { value, text });
    if (key == 'ejercicio')
        commit(SET_FILTER_EJERCICIO, { value, text });
}

const setAvailableEjercicios = ({ commit }, ejercicios) => {
    commit(SET_EJERCICIO_USER_VALUES, ejercicios);
}

const actions = {
    removeAllFilters,
    updateObject,
    setAvailableEjercicios
};

// MUTATIONS
const mutations = {
    [SET_FILTER_MES_DESDE](state, { value, text }) {
        Vue.set(state.dashboardFilters.mes_desde, 'value', value);
        Vue.set(state.dashboardFilters.mes_desde, 'text', text);
    },
    [SET_FILTER_MES_HASTA](state, { value, text }) {
        Vue.set(state.dashboardFilters.mes_hasta, 'value', value);
        Vue.set(state.dashboardFilters.mes_hasta, 'text', text);
    },
    [SET_FILTER_EJERCICIO](state, { value, text }) {
        Vue.set(state.dashboardFilters.ejercicio, 'value', value);
        Vue.set(state.dashboardFilters.ejercicio, 'text', text);
    },
    [SET_EJERCICIO_USER_VALUES](state, ejercicios) {
        // Transform array of years [2023, 2024, 2025] to user_values format
        const userValues = ejercicios.map(year => ({
            value: String(year),
            text: String(year)
        }));
        Vue.set(state.dashboardFilters.ejercicio, 'user_values', userValues);
    },
    [RESET_FILTERS](state) {
        Vue.set(state.dashboardFilters.mes_desde, 'value', '');
        Vue.set(state.dashboardFilters.mes_desde, 'text', '');
        Vue.set(state.dashboardFilters.mes_hasta, 'value', '');
        Vue.set(state.dashboardFilters.mes_hasta, 'text', '');
        Vue.set(state.dashboardFilters.ejercicio, 'value', '');
        Vue.set(state.dashboardFilters.ejercicio, 'text', '');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
